const MAXIRACE27_MODULE = 'MAXIRACE27';
const SESSION_KEY = 'maxirace27_reglement_opened';

import { useMainStore } from '@/stores/mainStore';



export function isMaxirace27ReglementGateRequired() {
    const mainStore = useMainStore();
    if (mainStore?.module?.base !== MAXIRACE27_MODULE) {
        return false;
    }
    return !!mainStore?.module?.url_reglement;
}

export function isMaxirace27ReglementOpened() {
    return sessionStorage.getItem(SESSION_KEY) === '1';
}

export function setMaxirace27ReglementOpened() {
    sessionStorage.setItem(SESSION_KEY, '1');
}

export function shouldBypassMaxirace27ReglementGate() {
    const mainStore = useMainStore();
    return mainStore.view_as_admin || mainStore.is_inscription_vip;
}
